import React from 'react';
import FormControl from "./FormControl";

const FormDropDown = (props) => {
    const { children, ...rest } = props;
    const { validations, register, name, id } = rest;
    return (
        <FormControl
            {...rest}
            render={({ inputClass }) =>
                <select
                    className={inputClass}
                    name={name}
                    id={id || name}
                    {...register(name, validations)}
                >
                    {children}
                </select>
            }
        />
    );
}

export default FormDropDown;